import React from "react";
import PropTypes from 'prop-types';
import CONST from "../../config/CONST";

const ResultTableItem = (props) => {

    const {
        value,
        label,
        className,
        vatDisclaimer
    } = props;

    return (
        <div className={`${CONST.CSS_NAMESPACE}ResultTableItem ${className || ``} ${CONST.CSS_NAMESPACE}row`}>
            { label &&
                <div className={`${CONST.CSS_NAMESPACE}ResultTableItem-Label`}>
                    <div className={`${CONST.CSS_NAMESPACE}ResultTableItem-LabelText`}>{label}</div>
                </div>
            }
            { value && <div className={`${CONST.CSS_NAMESPACE}ResultTableItem-Value`}>{value}</div> }
            { vatDisclaimer && <p className={`${CONST.CSS_NAMESPACE}ResultTableItem-Disclaimer`}>{vatDisclaimer}</p>}
        </div>
    );
};

ResultTableItem.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string
};

export default ResultTableItem;
